//引入常量对象
import CONSTANCE from "@/static/js/constance"

export default function() {
  return {
    //配置标题
    title: {
      //是否显示标题
      show: true,
      //标题内容
      text: '',
      //标题文字配置
      textStyle: {
        color: CONSTANCE.GRAPH_FONT_COLOR,
        fontStyle: 'normal',
        fontWeight: 'bold',
        fontFamily: CONSTANCE.FONT_FAMILY,
      },
      //设置标题距离左边的距离('left'、'10%', 10)
      left: 'left',
    },
    //配置图例
    legend: {
      //是否显示图例
      show: true,
      //设置图例文字
      textStyle: {
        color: CONSTANCE.GRAPH_FONT_COLOR,
        fontStyle: 'normal',
        fontFamily: CONSTANCE.FONT_FAMILY,
        fontSize: CONSTANCE.GRAPH_LEGEND_FONT_SIZE
      },
      //设置图例列表距离左边的距离('left'、'10%', 10)
      left: 'center',
      //距离顶部的距离（'bottom', '10%', 10）
      top: '10%',
      //图例列表的布局朝向（horizontal、vertical）
      orient: 'horizontal'
    },
    //x轴
    xAxis: {
      name: '',
      nameLocation: 'end',
      nameTextStyle: {
        //标签字体颜色
        color: CONSTANCE.GRAPH_FONT_COLOR,
        //字体样式
        fontStyle: 'normal',
        //字体粗细
        fontWeight: 'normal',
        //字体
        fontFamily: CONSTANCE.FONT_FAMILY
      },
      axisLabel: {
        //是否隐藏重叠的标签
        hideOverlap: true,
        //标签字体颜色
        color: CONSTANCE.GRAPH_FONT_COLOR,
        //字体样式
        fontStyle: 'normal',
        //字体粗细
        fontWeight: 'normal',
        //字体
        fontFamily: CONSTANCE.FONT_FAMILY
      },
      triggerEvent: true
    },
    //y轴
    yAxis: {
      name: '',
      nameLocation: 'end',
      nameTextStyle: {
        //标签字体颜色
        color: CONSTANCE.GRAPH_FONT_COLOR,
        //字体样式
        fontStyle: 'normal',
        //字体粗细
        fontWeight: 'normal',
        //字体
        fontFamily: CONSTANCE.FONT_FAMILY
      },
      axisLabel: {
        //是否隐藏重叠的标签
        hideOverlap: true,
        //标签字体颜色
        color: CONSTANCE.GRAPH_FONT_COLOR,
        //字体样式
        fontStyle: 'normal',
        //字体粗细
        fontWeight: 'normal',
        //字体
        fontFamily: CONSTANCE.FONT_FAMILY
      }
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow'
      }
    },
    grid: {
      top: '20%',
      left: '3%',
      right: '4%',
      bottom: '10%',
      containLabel: true
    },
    dataZoom: [
      {
        type: 'inside'
      },
      {
        type: 'slider',                     //滑动条
        showDetail: true,
        // xAxisIndex:0,                            //设置 dataZoom-inside 组件控制的 x轴,可以用数组表示多个轴
        // yAxisIndex:0,                        //设置 dataZoom-inside 组件控制的 y轴,可以用数组表示多个轴
        textStyle: {                        //文本样式
          color:CONSTANCE.GRAPH_FONT_COLOR,
          fontFamily: CONSTANCE.FONT_FAMILY
        },
        // backgroundColor:'transparent',
        orient:"horizontal",                    //布局方式是横还是竖。不仅是布局方式，对于直角坐标系而言，也决定了，缺省情况控制横向数轴还是纵向数轴。'horizontal'：水平。'vertical'：竖直。
        left:"30%",                           //组件离容器左侧的距离,'left', 'center', 'right','20%'
        top:"90%",                                //组件离容器上侧的距离,'top', 'middle', 'bottom','20%'
        right:"30%",                             //组件离容器右侧的距离,'20%'
        bottom:"0%",                            //组件离容器下侧的距离,'20%'
      }
    ]
  }
}